import React, { Component } from 'react';
import { Upload, Icon } from 'antd';
import { Label, Row } from './index';
export default class Avatar extends Component {
  constructor(props) {
    super(props);
    const { cStyle } = props;
    let config = null;
    if (cStyle) {
      try {config = JSON.parse(cStyle); } catch (e) {config = {}; } 
    }
    this.state = Object.assign({
      classname:props.className,
      displaymode: 'default',
      bIsNull: props.bIsNull,
      visible: !props.bHidden,
      caption: props.cShowCaption,
      err: '',
      msg: '',
      acceptType:'jpg,png',
      imgSize:2048,
      uploadtext:'上传图片'
    }, config);
    this.DocumentServerAddress = 'https://oivs4lxfc.bkt.clouddn.com';
    this.handleChange = this.handleChange.bind(this);
    const proxy = cb.rest.DynamicProxy.create({ getFileServerUrl: { url: '/pub/fileupload/getFileServerUrl.do', method: 'GET' } });
    proxy.getFileServerUrl((err, result) => {
      if (result)
        this.DocumentServerAddress = result;
    });
  }
  componentDidMount() {
    if (this.props.model)
      this.props.model.addListener(this);
  }
  componentWillUnmount() {
    if (this.props.model)
      this.props.model.removeListener(this);
  }
  setListenerState(params) {
    this.setState(params);
  }
  beforeUpload(file) {
    let {acceptType,imgSize} = this.state;
    let _typeArr = (file.name).split('.');
    let _type = _typeArr[_typeArr.length-1].toLowerCase();
    let _acceptArr = acceptType.split(',')
    let _isType = _acceptArr.includes(_type);
    if (!_isType)
      cb.utils.alert('图片仅支持'+acceptType+'格式', 'error');
    const isFileSize = file.size / 1024< imgSize;
    if (!isFileSize){
      cb.utils.alert('文件必须小于'+(imgSize<1024? imgSize+'K' :imgSize/1024+'M'), 'error');
    }
    return _isType && isFileSize;
  }
  handleChange = (info) => {
    if (info.file.status === 'done') {
      if (info.file.response.code == 200) {
        const value = this.DocumentServerAddress + info.file.response.data;
        if (this.props.model)
          this.props.model.setValue(value, true);
        cb.utils.alert(`${info.file.name} 上传成功！`, 'success');
      } else {
        cb.utils.alert(`${info.file.name} 上传失败！${info.file.response.code} : ${info.file.response.message}`, 'error');
      }
    } else if (info.file.status === 'error') {
      cb.utils.alert(`${info.file.name} 上传失败！${info.file.response.code} : ${info.file.response.message}`, 'error');
    }
  }
  validate(val) {
    this.setState({
      err: 'has-' + val.type,
      msg: val.message
    });
  }
  relatedControl() {
    const control = this.baseControl();
    const { relatedControl } = this.props;
    if (!relatedControl)
      return control;
    return (
      <div className='has-related'>
        <div className='viewCell'>{control}</div>
        {relatedControl}
      </div>
    );
  }
  handelDelete(){
    if (this.props.model)
      this.props.model.setValue(null, true);
  }
  getUploadControl = (control,className) => {
    let action = '/upload?token=' + cb.rest.AppContext.token;
    let {acceptType} = this.state;
    let _accept = '.'+acceptType.split(',').join(',.')
    return <Upload
      className={"avatar-uploader "+className}
      showUploadList={false}
      action={action}
      beforeUpload={this.beforeUpload.bind(this)}
      onChange={this.handleChange}
      accept={_accept}
    >
      {control}
    </Upload>
  }
  baseControl() {
    let {cCaption} = this.props;
    let { readOnly, value, tooltip, displaymode ,afterPopoverKey,after,bottom,acceptType,uploadtext} = this.state;
    // tooltip = after || tooltip || '仅支持'+acceptType.split(',').join('、').toUpperCase()+'格式' ;
    // tooltip 和 after 有可能设置为 '' 空字符串
    tooltip = after!==undefined ? after : (tooltip!==undefined ? tooltip : '仅支持'+acceptType.split(',').join('、').toUpperCase()+'格式')
    const className = `basic-avatar-${displaymode}`;
    if (readOnly){
      return value ? <div className='basic-avatar-browse-img-container'><img className={className} src={value} alt="" /></div>:<div className={`no-avatar-man ${className}`}></div>
    }
    let _baseControl= (
      <Row className={`face-img ${className}`}>
        {
          value ?
          <p className='basic-avatar-btn-item'>
            <img src={value} />
            {this.getUploadControl(<Icon type='uploadimg' />,'basic-avator-changeimg')}
            <strong onClick={this.handelDelete.bind(this)}  className='basic-avator-deleteimg'><Icon type="delete" /></strong>
          </p> :
          <p className='basic-avatar-btn-item basic-avatar-bg'>
            {this.getUploadControl(<strong><Icon type='uploadimg' />{uploadtext}</strong>,'basic-avator-uploadimg')}
          </p>
        }
        <div className="basic-avatar-right">{tooltip}</div>
      </Row>
    );
    if(!bottom){
      return _baseControl
    }else{
      return (
        <div className="input-bottom">
          <div className='control-flex'>{_baseControl}</div>
          <div className="input-bottom-text">{bottom}</div>
        </div>
      );
    }
  }
  getControl() {
    const {caption} = this.state;
    const title = !this.state.readOnly && this.state.bIsNull === false && caption ? <label><Icon type='star' />{caption}</label> : <label>{caption}</label>;
    let control = (caption ? <Label control={this.relatedControl()} title={title} /> : this.relatedControl());
    return control;
  }
  render() {
    const control = this.getControl();
    let {classname,visible,err,msg}=this.state;
    let style = visible ? {} : { display: "none" };
    let _className = classname+' basic-avatar has-feedback ' + err;
    return (
      <div style={style} className={_className}>
        {control}
        <div className="ant-form-explain">{msg}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/basic/avatar.jsx